import { Icon, IconButton } from "@material-ui/core";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { ButtonBase, Modal } from "@mui/material";
import React, { useState } from "react";
import popUp from '../assets/Popups/popup_image_icon.png'

const SlideOut = ({title, copy, bullets, stat, view}) => {

    const [modalOpen, setModalOpen] = useState(false)
    const [slideClose, setSlideClose] = useState(false)

    const handleModalOpen = () => setModalOpen(true);
  const handleModalClose = () => setModalOpen(false);

    return(
        <div className={`slideOutWrapper ${slideClose?'slideWrapper_close':'slideWrapper_open'}`}>
        <div className={`slide_out ${slideClose?'slide_close':'slide_open'}`}>
            <IconButton size='small' className={slideClose?'slide_in_arrow':'slide_out_arrow'} onClick={()=>setSlideClose(!slideClose)}>
                <ArrowRightIcon color="#00358E" fontSize="large"/>
            </IconButton> 
            <h2>{title}</h2>
            <p>{copy}</p>
            {bullets && (
                <ul>
                    {bullets.map((bullet, index) => bullet)}
                </ul>
            )}
            {(stat || view) && <hr />}
            {stat && (
                <div>
                    <h3 className="stat_header">Industry Stat</h3>
                    <img className="stat_graphic" src={stat.graphic} />
                    <p className="stat_copy">{stat.copy}</p>
                </div>
            )}
            {view && (
                <div>
                    <ButtonBase className="modal_link" onClick={handleModalOpen}>
                        <img src={popUp} />
                        <p>{view.copy}</p>
                    </ButtonBase>
                </div>
            )}
             { view && <Modal className='modal_wrapper' 
            
            open={modalOpen}
            onClose={handleModalClose}
            >
                <div className={view.vert?'modal_vert':'modal_horizontal'}>
                <div className = "modal_copy">
                    {view.header && <h2 className="modal_header">{view.header}</h2>}


                <p>
               {view.paragraph}
                </p>
                </div>

                <img className="modal_graphic" src={view.graphic} />
                </div>
            </Modal> }
            </div>
        </div>
    )
}

export default SlideOut